// Phone number patterns (Algerian + international)
const PHONE_PATTERNS = [
  /(?:\+?\d{1,3}[\s.-]?)?\(?\d{2,4}\)?[\s.-]?\d{2,4}[\s.-]?\d{2,4}[\s.-]?\d{0,4}/g,
  /0[5-7]\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}/g,
  /\+213\s?\d/g,
];

// Blocked keywords
const BLOCKED_KEYWORDS = [
  "whatsapp",
  "viber",
  "signal",
  "telegram",
  "appel",
  "appelle",
  "téléphone",
  "telephone",
  "numéro",
  "numero",
  "appelez",
  "contactez-moi au",
  "mon num",
];

/**
 * Returns a blocking reason if the message contains forbidden content, or null if clean.
 */
export function checkMessageContent(content: string): string | null {
  const normalized = content
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");

  // Check keywords
  for (const keyword of BLOCKED_KEYWORDS) {
    const normalizedKeyword = keyword
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    if (normalized.includes(normalizedKeyword)) {
      return "keyword_detected";
    }
  }

  // Check phone numbers - strip spaces/dots/dashes first
  const stripped = content.replace(/[\s.-]/g, "");
  // Match sequences of 8+ digits (likely phone numbers)
  const digitSequences = stripped.match(/\d{8,}/g);
  if (digitSequences && digitSequences.length > 0) {
    return "phone_number_detected";
  }

  // Also check with original formatting for patterns like "06 xx xx xx xx"
  for (const pattern of PHONE_PATTERNS) {
    pattern.lastIndex = 0;
    if (pattern.test(content)) {
      return "phone_number_detected";
    }
  }

  return null;
}
